'use client';
const MAX_RETRIES = 2;
const BACKOFF_TIME = 500;
const RESTRICTED_STATIC_ASSET_PREFIX = '/_pplx-restricted-static-assets/';
const pathRegex = /([`'"])((\w+:(\/?\/?))?[^\s,]+)\1/;
export function _getImportFnPath(importFn) {
    const fnString = importFn.toString();
    const match = fnString.match(pathRegex);
    if (!match)
        return null;
    return match.filter((e) => !!e)[2] ?? null;
}
export function _getRetryPath(path) {
    const retryPath = path.includes('?') ? `${path}&r=${Date.now()}` : `${path}?r=${Date.now()}`;
    if (retryPath.startsWith(RESTRICTED_STATIC_ASSET_PREFIX) && typeof window !== 'undefined') {
        return new URL(retryPath, window.location.origin).href;
    }
    return retryPath;
}
export async function _withRetry(importFn) {
    let path = null;
    let numRetries = 0;
    while (numRetries <= MAX_RETRIES) {
        try {
            return await (numRetries > 0 && typeof path === 'string'
                ? import(/* @vite-ignore */ _getRetryPath(path))
                : importFn());
        }
        catch (err) {
            if (!path) {
                // If we can extract the path, we can retry
                path = _getImportFnPath(importFn);
                if (!path)
                    numRetries = MAX_RETRIES;
            }
            if (numRetries === MAX_RETRIES) {
                const renderingError = new Error(err instanceof Error ? err.message : 'Dynamic import failed');
                renderingError.name = `ReactRenderingError`;
                renderingError.cause = err;
                throw renderingError;
            }
            await new Promise((resolve) => setTimeout(resolve, BACKOFF_TIME * Math.pow(2, numRetries)));
            numRetries++;
        }
    }
    throw new Error('Dynamic import code failed');
}
//# sourceMappingURL=DynamicShared.js.map